import { adminRoutes } from '../router'

const removeComponents = (route, parentPath = '') => {
  return {
    path: parentPath ? `${parentPath}/${route.path}` : route.path,
    meta: Object.assign({}, route.meta, {
      title: route.meta.title || route.path
    }),
    children: route.children
      ? route.children.reduce((arr, child) => {
        const editTest = new RegExp('edit', 'ig')
        if (child.path && editTest.test(child.path)) {
          return arr
        }
        return arr.concat(removeComponents(child, parentPath ? `${parentPath}/${route.path}` : route.path))
      }, [])
      : []
  }
}
export const navHelper = adminRoutes.reduce((arr, route) => {
  if (route.path) {
    arr.push(removeComponents(route))
  }
  return arr
}, [])

export default navHelper
